var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPixelHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_7047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0658 0.0876465H35.7456V7.35246H57.0658V0.0876465Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5346 0.0876465H7.21436V7.35246H28.5346V0.0876465Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1398 7.35492H57.0658V34.3589H50.1679V41.5704H42.9571V48.7094H35.7456V55.9209H42.9571V48.7812H50.1679V41.5704H57.3786V34.3597H64.1398V7.35492Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21446 7.35492H0.139648V34.3597H7.21446V7.35492Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7454 55.9615H28.5347V63.1722H35.7454V55.9615Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3542 41.5704H14.2848V34.5002H7.07324V41.7118H14.1434V48.7812H21.29V55.9278H28.5008V48.7163H21.3542V41.5704Z",
    fill: "#DD98EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7454 7.35492H28.5347V14.5657H35.7454V7.35492Z",
    fill: "#DD98EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_7047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPixelHeart);
export default __webpack_public_path__ + "static/media/icon-pixel-heart.b598c8a256faf9aeb8f735e3be66813d.svg";
export { ForwardRef as ReactComponent };